import '@/styles/language-selector.css';
import { useCallback } from 'react';
import { flagUrl } from '@/lib/flagUrl';
import { localeFlags, type Locale } from '@/lib/i18n';
import { useLocale } from '@/context/LocaleContext';
import { useSettings, useUpdateSettingsGeneral } from '@/hooks/useSettings';

interface LanguageSelectorProps {
  className?: string;
}

export function LanguageSelector({ className = '' }: LanguageSelectorProps) {
  const { locale, setLocale } = useLocale();
  const { data } = useSettings();
  const updateGeneral = useUpdateSettingsGeneral();

  const handleSelect = useCallback(
    (code: Locale) => {
      if (code === locale) return;
      setLocale(code);

      // Persistir en cuenta para que no vuelva a EN al reabrir / navegar
      const timezone = data?.accountSettings?.timezone ?? '';
      const country = data?.accountSettings?.country ?? '';
      void updateGeneral.mutateAsync({ language: code, timezone, country }).catch(() => {
        // UI ya cambió; si falla el save, localStorage sigue siendo la fuente de verdad
      });
    },
    [data?.accountSettings?.country, data?.accountSettings?.timezone, locale, setLocale, updateGeneral],
  );

  return (
    <div className={`language-selector ${className}`.trim()}>
      {localeFlags.map(({ code, flagCode, name }) => (
        <button
          key={code}
          type="button"
          className={`lang-flag ${locale === code ? 'active' : ''}`}
          title={name}
          aria-label={name}
          aria-pressed={locale === code}
          onClick={() => handleSelect(code as Locale)}
        >
          <img
            src={flagUrl(flagCode)}
            alt=""
            width={24}
            height={24}
            decoding="async"
          />
        </button>
      ))}
    </div>
  );
}
